import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { AspectRatio } from '#app/components/layout/aspect-ratio.tsx'
import blueSkies from '../images/sarah-lee-ydpczVKWl4w-unsplash.jpg'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'AspectRatio',
}

const component: componentProps = {
	name: 'Aspect Ratio',
	shortName: 'AspectRatio',
	fileName: 'aspect-ratio',
	category: 'layout',
	description: ['Displays content in a desired ratio.'],
	features: ['Accepts any custom ratio.'],
	parts: [
		{
			name: 'AspectRatio',
			description: 'Displays content within a desired ratio.',
			props: [{ name: 'ratio', type: 'number', default: '1', description: 'The ratio to display the content within.' }],
		},
	],
	usage: `<AspectRatio ratio={16 / 9}>
	<img src="https://images.unsplash.com/photo-1558728112-33eea323814f" alt="Sunrise over the sea, by Sarah Lee on Unsplash" className="h-full w-full rounded-xl object-cover" />
</AspectRatio>`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const AspectRatioRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<AspectRatio ratio={16 / 9}>
				<img src={blueSkies} alt="Sunrise over the sea, by Sarah Lee on Unsplash" className="h-full w-full rounded-xl object-cover" />
			</AspectRatio>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
		</>
	)
}
export default AspectRatioRoute
